import React from 'react';
import { render, screen } from '@testing-library/react';
import { Icon } from './Icon';

describe('Icon', () => {
	it('Icon should not render and console warn if no name prop', () => {
		jest.spyOn(global.console, 'warn');
		console.warn = jest.fn(); // Prevent actual console.warn from showing up in command line

		render(<Icon role="img" />);
		const icon = screen.queryByRole('img');

		expect(icon).toBeNull();
		expect(console.warn).toBeCalled();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Icon
				name="search"
				size={20}
				role="img"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
